
import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useIsAuthenticated } from "@azure/msal-react";
import isLoggedIn from '../utils/auth';

import { 
  getNeedsPasswordReset, 
} from '../utils/auth';


const PrivateRoute = () => {

  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if(!isLoggedIn() && !isAuthenticated) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  // if(getNeedsPasswordReset()) {
  //   return <Navigate to='/login' state={{ from: location }} replace />;
  // }

  return <Outlet />;
};

export default PrivateRoute;